import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.getElementById("first-cta");
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="gpm49h66sr5z">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur" data-id="element-34" data-mp="goayjbt6l9c8">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-35" data-mp="2b3i86hg9brnz">
            <div className="hidden shrink-0 flex-col leading-tight sm:flex" data-id="element-36" data-mp="2f3sl6e2gvicc">
              <span className="text-xs text-white/60 line-through" data-id="element-37" data-mp="2f5vbkz7j7dhl">$244</span>
              <span className="text-2xl font-black text-gold" data-id="element-38" data-mp="21cdurm68cev9">$27</span>
            </div>
            <a href={CHECKOUT_URL} className="animate-cta-shake flex min-h-[56px] flex-1 items-center justify-center gap-2 rounded-2xl bg-brand px-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-cta transition-colors duration-150 ease-out hover:bg-brand-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-base" data-id="element-39" data-mp="26a5wf7woffcn">
              <span className="whitespace-nowrap" data-id="element-40" data-mp="1nez0o4517iwy">Get Instant Access — $27</span>
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-41" data-mp="3cscau9zts15z" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}